class DZModelTraffic{
    /**
     * 主键
     */
    id = "";

    /**
     * 土地信息ID
     */
    landId = "";

    /**
     * 距离机场时间
     */
    toAirport = "";

    /**
     * 距离高速公路时间
     */
    toSpeed = "";

    /**
     * 距离铁路时间
     */
    toRailway = "";

    /**
     * 距离港口时间
     */
    toPort = "";

    /**
     * 距离高铁时间
     */
    toHeightSpeed = "";

    /**
     * 距离省级公路时间
     */
    toProvincialRoad = "";

    /**
     * 距离国道时间
     */
    toNationalHighway = "";

    /**
     * 距离县级公路时间
     */
    toCountyHighway = "";

    /**
     * 距离乡镇公路时间
     */
    toTownshipHighway = "";

    /**
     * 距离村道/自建路时间
     */
    toVillageRoad = "";

    /**
     * 距离公交时间
     */
    toTransit = "";

    /**
     * 更新用户ID
     */
    updateBy = "";

    /**
     * 更新时间
     */
    updateTime = "";

    /**
     * 发布用户ID
     */
    createBy = "";

    /**
     * 创建时间
     */
    createTime = "";
}
export default DZModelTraffic